import { useQuery } from 'react-query';

import { QueryKey } from '@config/queryKey';
import { getQuery } from '@queries/queries';
import { PoolType } from '@config/base';

interface MarketGraphInfo {
  timestamp: Date;
  borrowApyPercent: number;
  supplyApyPercent: number;
  totalBorrowUsd: number;
  totalSupplyUsd: number;
  id: string;
}

export interface MarketHistory {
  loading: boolean;
  info?: MarketGraphInfo[];
}

export interface MarketInfoResponse {
  timestamp: string;
  borrowRate: number;
  supplyRate: number;
  totalBorrowUsd: number;
  totalSupplyUsd: number;
  id: string;
}

export default function useMarketHistory(symbol: string, poolType: PoolType) {
  const query = getQuery(QueryKey.API_MARKET_HISTORY)(symbol, poolType);
  return useQuery(query.queryKey, query.queryFn, {
    enabled: !!symbol,
    refetchInterval: 20000,
  });
}
